<template>
  <div class="flex1">
    <div class="row">
      <div class="col-md-12 col-12">
        <h3>Update catalog</h3>
        <div class="row mb-3" v-for="(change, index) in catalogChanges" :key="`optionToChange-${index}`">
          <div class="col-md-4 col-12">
            <label><span class="pointer" @click="setDocType(index, 'update')"
                :style="!isNew('docTypes', index) ? 'color:#fff' : ''">Update a product</span>
              /
              <span class="pointer" href="#" @click="setDocType(index, 'new')"
                :style="isNew('docTypes', index) ? 'color:#fff' : ''">
                Add new product
              </span></label>
            <select v-model="catalogChanges[index].doc" class="form-control" v-if="docTypes[index] != 'new'">
              <option disabled value="">Please select a product Id</option>
              <option v-for="pid in producIds" :key="'pidSelect-' + pid">
                {{ pid }}
              </option>
            </select>
            <input v-else class="form-control" type="text" v-model.trim="catalogChanges[index].doc" />
          </div>
          <div class="col-md-2 col-12">
            <label>
              <span class="pointer" @click="setKeyType(index, 'update')" :style="!isNew('keyTypes', index) ? 'color:#fff' : ''
                ">Select a pgn</span>
              /
              <span class="pointer" href="#" @click="setKeyType(index, 'new')"
                :style="isNew('keyTypes', index) ? 'color:#fff' : ''">
                Add new pgn
              </span>
            </label>
            <select v-model="catalogChanges[index].pgn" class="form-control" v-if="keyTypes[index] != 'new'">
              <option disabled value="">Please select a pgn</option>
              <option v-for="type in pgns" :key="'typeSelect-' + type">
                {{ type }}
              </option>
            </select>
            <input v-else class="form-control" type="number" v-model="catalogChanges[index].pgn" />
          </div>
          <div class="col-md-1 col-12">
            <label>tier</label>
            <input class="form-control" type="text" v-model="catalogChanges[index].tier" />
          </div>
          <div class="col-md-1 col-12">
            <label>Price</label>
            <input class="form-control" type="number" v-model="catalogChanges[index].price" />
          </div>
          <div class="col-md-1 col-12">
            <label>Intro price</label>
            <input class="form-control" type="number" v-model="catalogChanges[index].intro_price" />
          </div>
          <div class="col-md-1 col-12">
            <label>FT Dur in Days</label>
            <input class="form-control" type="number" v-model="catalogChanges[index].ft_duration" />
          </div>
          <div class="col-md-1 col-12">
            <label>Product Duration</label>
            <select v-model="catalogChanges[index].product_duration" class="form-control">
              <option disabled value="">Please select a product duration</option>
              <option v-for="duration in productDurations" :key="'typeSelect-' + duration">
                {{ duration }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-12 text-center mt-3">
          <button class="btn mx-2" @click="catalogChanges.push({})">
            Another change
          </button>
          <button class="btn btn-primary mx-2" @click="submitChanges()">
            {{ status == "ready" ? "Update Catalog" : "Submitting" }}
          </button>
        </div>
      </div>

    </div>
    <div class="col-md-12 col-12">
      <h3>Current Catalog</h3>
      <div>
        <div class="card row py-2">
          <div class="col-12">
            <div class="row">
              <div class="col-4">
                <p>Product</p>
              </div>
              <div class="col-1">
                <p>#</p>
              </div>
              <div class="col-1">
                <p>Tier</p>
              </div>
              <div class="col-1">
                <p>Price</p>
              </div>
              <div class="col-1">
                <p>Intro Price</p>
              </div>
              <div class="col-1">
                <p>FT Duration</p>
              </div>
              <div class="col-1">
                <p>Product Duration</p>
              </div>
              <div class="col-2">
                <p>Actions </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row" v-for="product in appCatalog" :key="product.product_id">
              <div class="col-4">
                <p>{{ product.product_id }}</p>
              </div>
              <div class="col-1">
                <p>{{ product.pgn }}</p>
              </div>
              <div class="col-1">
                <p>{{ product.tier }}</p>
              </div>
              <div class="col-1">
                <p>${{ product.price }}</p>
              </div>
              <div class="col-1">
                <p v-if="product.intro_price">${{ product.intro_price }}</p>
              </div>
              <div class="col-1">
                <p>{{ product.ft_duration }}</p>
              </div>
              <div class="col-1">
                <p>{{ product.product_duration }}</p>
              </div>
              <div class="col-2">
                <button class="btn btn-info btn-sm mr-4" @click="goToOffers(product.product_id)">Promo Offers</button>
                <button class="btn btn-danger btn-sm" @click="deleteProduct(product.product_id)">DEL</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      catalogChanges: [{}],
      status: "ready",
      docTypes: ["update"],
      keyTypes: ["update"],
      productDurations: ["1 Week", "2 Week", "1 Month", "3 Month", "6 Month", "12 Month", "lifetime", "consumable"]
    };
  },
  created() {
    console.log()
  },
  computed: {
    catalog() {
      return this.$store.getters.catalog
    },
    appCatalog() {
      const appCatalog = this.catalog.filter(item => item.app_id == this.$route.params.id)
      appCatalog.sort((a, b) => (a.pgn - b.pgn))
      return appCatalog;
    },
    producIds() {
      return this.appCatalog.map(item => item.product_id)
    },
    pgns() {
      const pgns = []
      this.appCatalog.forEach(item => {
        if (item.pgn && pgns.indexOf(item.pgn) < 0) {
          pgns.push(item.pgn)
        }
      })
      pgns.sort((a, b) => a - b)
      return pgns
    }
  },
  methods: {
    submitChanges() {
      // this.status = "submitting";
      const payload = {};
      this.catalogChanges.forEach((item) => {
        //remove all whitespaces if there are any
        if (!payload[item.doc]) payload[item.doc.replace(/ /g, '')] = {}
        console.log(item.doc);
        payload[item.doc] = {
          app_id: this.$route.params.id,
          pgn: item.pgn ? Number(item.pgn) : undefined,
          tier: item.tier,
          price: item.price ? Number(item.price) : undefined,
          intro_price: item.intro_price ? Number(item.intro_price) : undefined,
          ft_duration: item.ft_duration ? Number(item.ft_duration) : undefined,
          product_duration: item.product_duration,
        }
      });
      console.log(payload)
      this.catalogChanges = [{}]
      this.$store.dispatch('updateCatalog', payload)
    },
    setDocType(index, str) {
      this.$set(this.docTypes, index, str)
    },
    setKeyType(index, str) {
      this.$set(this.keyTypes, index, str)
    },
    isNew(key, index) {
      return this[key][index] == 'new'
    },
    deleteProduct(id) {
      if (!confirm(`Are you sure you want to delete product "${id}"? This cannot be undone.`)) {
        return
      }
      this.$store.dispatch('deleteProduct', id)
    },
    goToOffers(productId) {
      this.$router.push({ name: 'PromotionalOffers', params: { id: this.$route.params.id, productId } })
    }
  },
};
</script>
